import { motion } from "framer-motion";
import { FacebookIcon, LinkedinIcon, TwitterIcon } from "../icons";
import { navigationsFooter } from "../utils/common";

export default function Footer() {
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  return (
    <footer className="mt-6 pb-6 pt-16 bg-primary-40 rounded-3xl flex flex-col justify-center items-center gap-4">
      <motion.a
        href="/"
        initial="hidden"
        whileInView="visible"
        variants={fadeIn}
        transition={{ duration: 1 }}
      >
        <img src="/assets/logo/logo.png" className="w-44 h-32" />
      </motion.a>
      <motion.h5
        className="text-primary-55 font-light text-sm md:text-lg max-w-2xl text-center px-6 md:px-0"
        initial="hidden"
        whileInView="visible"
        variants={fadeIn}
        transition={{ duration: 1, delay: 0.2 }}
      >
        Est une entreprise franco-africaine qui se propose de démocratiser
        l'accès à la mobilité à de millions de travailleurs indépendants du
        secteur informel
      </motion.h5>
      <motion.ul
        className="md:flex grid grid-cols-2 items-center gap-8"
        initial="hidden"
        whileInView="visible"
        variants={fadeIn}
        transition={{ duration: 1, delay: 0.4 }}
      >
        {navigationsFooter.map((item) => (
          <motion.a key={item.name} href={item.href}>
            <li className="cursor-pointer font-normal text-sm md:text-lg text-header text-primary-45 hover:text-primary-45/80">
              {item.name}
            </li>
          </motion.a>
        ))}
      </motion.ul>
      <motion.div
        className="flex items-center gap-4 mt-8 md:mt-16"
        initial="hidden"
        whileInView="visible"
        variants={fadeIn}
        transition={{ duration: 1, delay: 0.6 }}
      >
        <FacebookIcon />
        <TwitterIcon />
        <a
          href="https://www.linkedin.com/company/infinx-mobility/"
          target="_blank"
        >
          <LinkedinIcon />
        </a>
      </motion.div>
    </footer>
  );
}
